// Import React and necessary dependencies
import React, { useEffect, useState } from "react";
import { Col, Container, OverlayTrigger, Popover, Row, Table } from "react-bootstrap"; // Import components from react-bootstrap
import Tablepart from "../../src/components/tablepart"; // Import the Tablepart component
import Bidtab from "../../src/components/bidtab"; // Import the Bidtab component
import ExportApi from "../api/ExportApi"; // Import an API utility
import StokChart from "./StokChart"; // Import the StokChart component
import { LazyLoadImage } from "react-lazy-load-image-component"; // Import LazyLoadImage for lazy-loading images
import "react-lazy-load-image-component/src/effects/blur.css"; // Import a CSS effect
import { toast, ToastContainer } from "react-toastify"; // Import toast notifications
import { useParams } from "react-router-dom"; // Import useParams from react-router-dom for routing
import InfoSvg from "../assets/svg/infoSvg";
import { Tooltip as ReactTooltip } from "react-tooltip";
import QuestionMarkSvg from "../assets/svg/QuestionMarkSvg";

// Define and export the Placeask component
export default function Placeask(props) {
  let imageUrl = process.env.REACT_APP_IMAGEBASEURL;
  const params = useParams();
  const [Data, setData] = useState([]);
  const [ask, setAsk] = useState([]);
  const [Bid, setBid] = useState([]);
  const [bidAmount, setBidAmount] = useState();
  const [heighBidId , setHighestBidId] = useState("")
  const [askAmount, setAskAmount] = useState();
  const [count, setCount] = useState(0);
  const [secondHouseAskPrice, setSecondHouseAskPrice] = useState();
  const [secondHouseBidPrice, setSecondHouseBidPrice] = useState();
  const [websitePrice, setWebsitePrice] = useState();
  const [usedPrice, setUsedPrice] = useState();
  const [productType, setProductType] = useState();
  const [usedBidPrice, setUsedBidPrice] = useState();
  const [count1, setCount1] = useState(0);
  const [userId, setUserId] = useState(0);
  const [image, setImage] = useState([]);
  const [currentSortOrder, setCurrentSortOrder] = useState(1);
  const [currentSortKey, setCurrentSortKey] = useState(null);
  const [shippingFee, setShippingFee] = useState();
  const [isLoading, setLoading] = useState(false);
  const [shippingFeeError, setShippingFeeError] = useState(false);

  const [finalPriceBuy, setFinalPriceBuy] = useState();
  const [finalPriceSell, setFinalPriceSell] = useState();
  const [productId, setProductId] = useState(null);
  const [loader, setLoader] = useState({
    bidLoader: true,
    askLoader: true,
    productDataLoader: true
  })

  // Function to fetch product data
  const handleSearch = () => {
    setLoading(true); // Set loading state to true
    let user = JSON.parse(localStorage.getItem("tokenuser"));
    let userIds = user ? user.id : "";
    ExportApi.GetSingleProductData(props.prams, userIds)
      .then((resp) => {
        setData(resp.data.Data);
        setSecondHouseBidPrice(resp.data.Data.new_second_hand_house_bid);
        setSecondHouseAskPrice(resp.data.Data.new_second_hand_house_ask);
        setWebsitePrice(resp.data.Data.new_retail_website_price);
        setUsedPrice(resp.data.Data.used_house_ask);
        setUsedBidPrice(resp.data.Data.used_house_bid);
        setProductType(resp.data.Data.type);
        setImage(resp.data.Data.image[0]);
        setProductId(resp.data.Data._id);
        if (resp.data.Data.type === 1) {
          setFinalPriceBuy(resp.data.Data.new_retail_website_price);
          setFinalPriceSell(null);
        } else {
          setFinalPriceBuy(resp?.data?.Data?.lowest_ask);
          setFinalPriceSell(resp?.data?.Data?.highest_bid);
        }

        setLoading(false); // Set loading state to false
        setLoader((prev) => ({
          ...prev,
          productDataLoader: false
        }))
      })
      .catch((err) => {
        setLoader((prev) => ({
          ...prev,
          productDataLoader: false
        }))
        console.log(err)
      });
  };

  // Function to fetch ask data
  const handleAsk = () => {
    ExportApi.getask(productId)
      .then((resp) => {
        if (resp?.data?.data?.length > 0) {
          setAsk(resp?.data?.data);
          setAskAmount(resp?.data?.data[0]?.askAmount);
          setShippingFee(resp?.data?.data[0]?.shippingFee)
          setCount(1);
          setLoader((prev) => ({
            ...prev,
            askLoader: false
          }))
        } else {
          setCount(2);
          setAsk([]);
          setLoader((prev) => ({
            ...prev,
            askLoader: false
          }))
        }
      })
      .catch((err) => {
        console.log(err)
        setLoader((prev) => ({
          ...prev,
          askLoader: false
        }))
      });
  };

  // Function to sort ask table
  const sortAskHere = (key) => {
    const sortOrder = key === currentSortKey ? -currentSortOrder : 1;
    const sortedProducts = ask.sort((a, b) => {
      if (a[key] < b[key]) return -1 * sortOrder;
      if (a[key] > b[key]) return sortOrder;
      return 0;
    });
    setCurrentSortKey(key);
    setCurrentSortOrder(sortOrder);
  };

  // Function to fetch bid data
  const handleBid = () => {
    ExportApi.getBid(productId)
      .then((resp) => {
        if (resp.data.data?.length > 0) {
          setCount1(1);
          const groupedBids = resp?.data?.data.reduce((acc, val) => {
            if (!acc[val.bidAmount]) {
              acc[val.bidAmount] = { ...val, quantity: val.quantity || 1 };
            } else {
              acc[val.bidAmount].quantity += val.quantity || 1;
            }
            return acc;
          }, {});

          const uniqueBids = Object.values(groupedBids);
          setBid(uniqueBids);
          setBidAmount(resp.data.data[0].bidAmount);
          setHighestBidId(resp.data.data[0]._id ?? "")
          setShippingFee(resp?.data?.data[0]?.shippingFee)
          setLoader((prev) => ({
            ...prev,
            bidLoader: false
          }))
        } else {
          setCount1(2);
          setBid([]);
          setLoader((prev) => ({
            ...prev,
            bidLoader: false
          }))
        }
      })
      .catch((err) => {
        console.log(err)
        setLoader((prev) => ({
          ...prev,
          bidLoader: false
        }))
      });
  };

  // Function to sort bid table
  //key used for the column name which we have to sort
  const sortBidHere = (key) => {
    const sortOrder = key === currentSortKey ? -currentSortOrder : 1;
    const sortedProducts = Bid.sort((a, b) => {
      if (a[key] < b[key]) return -1 * sortOrder;
      if (a[key] > b[key]) return sortOrder;
      return 0;
    });
    setCurrentSortKey(key);
    setCurrentSortOrder(sortOrder);
  };

  // Function to handle shipping fee
  const HandleShippingFee = async (userId) => {
    const shippingFeeResult = await ExportApi.getshippingFee(userId);
    if (shippingFeeResult.data.message === "Data fetched successfully") {
      setShippingFee(Number(shippingFeeResult?.data?.Data?.shippingFee));
      setShippingFeeError(false);
    } else if (
      params.buy === "buy" ||
      params.buy === "sell" ||
      params.buy === undefined
    ) {
      // toast.error(shippingFeeResult?.data?.message);
      // setShippingFeeError(true);
    }
  };

  // Effect to fetch data when the component mounts
  useEffect(() => {
    handleSearch();
  }, []);

  useEffect(() => {
    if (!productId) return;
    handleAsk();
    handleBid();
  }, [productId])

  useEffect(() => {
    if (!productId) return;
    window.addEventListener("List", () => {
      handleAsk();
      handleBid();
    });
  }, [productId])

  // Effect to listen for custom events and refresh data
  useEffect(() => {
    window.addEventListener("List", () => {
      handleSearch();
    });
  }, []);

  // Effect to get user ID and handle shipping fee
  useEffect(() => {
    if (localStorage.getItem("tokenuser")) {
      setUserId(JSON.parse(localStorage.getItem("tokenuser")).id);
      // HandleShippingFee(JSON.parse(localStorage.getItem("tokenuser")).id);
    } else if (localStorage.getItem("admin")) {
      setUserId(JSON.parse(localStorage.getItem("admin")).id);
      // HandleShippingFee(JSON.parse(localStorage.getItem("admin")).id);
    } else {
    }
  }, [localStorage.getItem("tokenuser"), localStorage.getItem("admin")]);

  // Conditional rendering for loading indicator
  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <div className="loader-icon" style={{ marginBlock: "80px" }}>
          <i className="fa-solid fa-spinner fa-spin-pulse"></i>
        </div>
      </div>
    );
  }

  // Render the main content of the component
  return (
    <div className="ask-part custom-font">
      <Container className="py-5">
        <Row>
          <Col xs="12" lg="8">
            {/* Render product information */}
            <h1 
              style={{ 
                fontSize: 'clamp(20px, 4vw, 28px)', 
                // fontWeight: 600, 
                marginBottom: '0px',
                lineHeight: '1.2',
                color: '#262626'
              }}
              // className="text-center text-4xl md:text-5xl font-bold mb-2 text-foreground"
               >
                {`${Data?.brand}  ${Data?.series} ${Data?.model}`}
              </h1>
              
            {/* MPN */}
              <p style={{ 
                fontSize: 'clamp(14px, 2vw, 16px)', 
                fontWeight: 500,
                marginBottom: '0px',
                color: '#262626',
              }}>
                 {Data?.sku !== "undefined" && Data?.sku !== "" ? <>MPN: {Data?.sku}</> : ""}
               </p> 

               {/* UPC */}
               <p style={{ 
                   fontWeight: 500, 
                   marginBottom: '0px',
                   padding: 0,
                   fontSize: 'clamp(14px, 2vw, 16px)',
                   color: '#262626',
                 }}>
                 {Data?.upc !== "undefined" && Data?.upc !== "" ? <>UPC: {Data?.upc}</> : ""}
                 </p> 

                 <p style={{ 
              fontSize: 'clamp(14px, 2vw, 16px)',
              marginBottom: 'clamp(8px, 2vw, 12px)',
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              gap: 'clamp(4px, 1vw, 8px)',
              fontWeight: 600,
              color: '#00427A'
            }}>
              <span>Condition :</span>
              <span> 
              {Data?.type == 2 ? " New(Resale)" : " Used(Tested)"}
              </span>

              {/* Info Icon with Tooltip */}
              <span style={{ display: 'inline-flex', alignItems: 'center', color: 'black' }} className="custom-font">
                <ReactTooltip
                  className="custom-tooltip text-center"
                  anchorId="condition-tooltip"
                  place="bottom"
                  style={{ maxWidth: "240px" }}
                  clickable={true}
                  closeOnScroll={false}
                  content={
                    Data?.type == 2 ? (
                      <>
                        This Item is brand new and sealed, sold by a third party seller. Box may have prior
                        ownership or retail labels. OEM manufacturer warranty is not guaranteed and may vary by
                        brand. GPUwiz will verify item meets our New (Resale) condition requirements prior to
                        shipment.{" "}
                        <a
                          href={`${process.env.REACT_APP_REDIRECT_URI}/help/quality-standards`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ textDecoration: "underline" }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          Learn more
                        </a>
                      </>
                    ) : (
                      <>
                        GPUwiz Verified. Meets GPUwiz Quality Standards. We physically test each card at stock
                        settings: fans (RPM sweep), ports, artifact-free bench, power/clock near spec, temps &
                        hotspot delta in range; cosmetics meet standard. Serial logged. Includes the GPUwiz
                        Verified Test Card. Manufacturer warranty is not guaranteed and may vary by brand.{" "}
                        <a
                          href={`${process.env.REACT_APP_REDIRECT_URI}/help/quality-standards`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ textDecoration: "underline" }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          Learn more
                        </a>
                      </>
                    )
                  }
                />
                <span id="condition-tooltip" style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}>
                  <QuestionMarkSvg />
                </span>
              </span>

            </p>

            <div className="inner-bid-cont d-flex align-items-start md:gap-4 gap-2 mt-5">
              <div className="bid_product_image">
                <LazyLoadImage
                  src={`${image}`}
                  effect="blur"
                />
              </div>
              {Data?.type == 1 ? (
                ""
              ) : (
                <>
                  <div className="d-flex align-items-start justify-content-center gap-4 mt-5">
                    <div className="bid-table">
                      <p className="bidask_label text-center">Bids</p>
                      <Table responsive="sm" striped bordered hover>
                        <thead>
                          <tr>
                            <th onClick={() => sortBidHere("bidAmount")}>
                              Bid{" "}
                            </th>
                            <th>Qty</th>
                          </tr>
                        </thead>
                        <tbody>
                          {count1 == 0 ? (
                            <tr>
                              <td>
                                <i className="fa-solid fa-spinner fa-spin-pulse"></i>
                              </td>
                            </tr>
                          ) : count1 == 1 ? (
                            <>
                              {Bid?.length > 0 || secondHouseBidPrice
                                ? Bid.map((val) => {
                                  return val?.userId == userId ? (
                                    <>
                                      <tr
                                        style={{ backgroundColor: "#75b299" }}
                                      >
                                        <td>${val?.bidAmount}</td>
                                        <td> {val?.quantity}</td>
                                      </tr>
                                    </>
                                  ) : (
                                    <>
                                      <tr>
                                        <td>${val?.bidAmount}</td>
                                        <td> {val.quantity}</td>
                                      </tr>
                                    </>
                                  );
                                })
                                : null}
                            </>
                          ) : (
                            <tr>
                              <td colSpan="2" className="text-center">
                                No Bids{" "}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                    <div className="bid-table">
                      {/* Render the Tablepart component for asks */}
                      <Tablepart
                        h1={"Quantity"}
                        h2={"Ask"}
                        data={ask}
                        amount={secondHouseAskPrice}
                        count={count}
                        sortAskHere={sortAskHere}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
            {/* Render the StokChart component */}
            {/* <StokChart /> */}
          </Col>
          <Col xs="12" lg="4" className="my-2">
            {/* Render the Bidtab component */}
            {
              !loader.bidLoader && !loader.askLoader && !loader.productDataLoader && (
                <Bidtab
                  Bidid={heighBidId}
                  Askid={ask?.[0]?._id}
                  Bid={bidAmount}
                  Ask={askAmount}
                  website={websitePrice}
                  used={usedPrice}
                  second={secondHouseAskPrice}
                  secondBid={secondHouseBidPrice}
                  usedBid={usedBidPrice}
                  type={productType}
                  shippingFee={shippingFee}
                  error={shippingFeeError}
                  finalPriceBuy={finalPriceBuy}
                  FinalPriceSell={finalPriceSell}
                  productId={productId}
                  productSlug={props.prams}
                  handleSearch={handleSearch}
                  handleBid={handleBid}
                  handleAsk={handleAsk}
                />
              )
            }
          </Col>
        </Row>
      </Container>
      {/* Render the ToastContainer for notifications */}
      <ToastContainer />
    </div>
  );
}
